import script from "./IconDelete.vue?vue&type=script&setup=true&lang=js"
export * from "./IconDelete.vue?vue&type=script&setup=true&lang=js"

import "./IconDelete.vue?vue&type=style&index=0&id=562d6d6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-562d6d6a"]])

export default __exports__